import React from 'react';
import { CandidateAssessmentsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CandidateAssessmentsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
